import { api } from '@creditsights/api-ui-web';
import { Snippet, SnippetList, SnippetParams, SnippetType } from '../../models';
import { Announcement } from '../../models/Announcement';
import { AnnouncementListDto } from '../dtos/announcement.dto';
import { SortOption } from '../services.constants';

const moduleV1Uri = '/common/v1/snippets';

export const fetchSnippet = async (type: SnippetType, id: string): Promise<Snippet> => {
  const { data } = await api.get<Snippet>(`${moduleV1Uri}/${type}/${id}`);
  return data;
};

export const fetchSnippets = async ({ type, tags }: SnippetParams): Promise<Snippet[]> => {
  const { data } = await api.post<SnippetList>(`${moduleV1Uri}/${type}`, {
    skip: 0,
    take: 10,
    myCS: false,
    sort: SortOption.publishDate_desc,
    tags,
  });
  return data.results;
};

export const fetchAnnouncements = async (): Promise<Announcement[]> => {
  const { data } = await api.post<AnnouncementListDto>(`${moduleV1Uri}/announcement`, {
    take: 4,
    sort: SortOption.publishDate_desc,
    myCS: false,
  });
  return data.results;
};
